import { CenteredSpinner } from "@Components/Page";
import { Button, EmptyState, ErrorIcon, SearchField, SearchIcon, Spinner, TreeList } from "@UI";
import { getIconFromType } from "@Utils/tree/getIconFromType";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
function localise(items, t) {
    return items.map((item)=>({
            ...item,
            title: item.isAbstract ? t(`workflows.folders.${item.type}`) : item.title,
            children: item.children && localise(item.children, t)
        }));
}
export function WorkflowTree({ tree, label, searchPlaceholder, emptyIcon: EmptyIcon, emptyTitle, emptyText }) {
    const { t } = useTranslation();
    const items = useMemo(()=>localise(tree.items, t), [
        tree.items,
        t
    ]);
    const { onSearch: handleSearch, onSelectedItemsChange: handleSelectedItemsChange, onExpandedItemsChange: handleExpandedItemsChange, retry: handleRetry } = tree;
    if (tree.hasError) {
        return /*#__PURE__*/ React.createElement(EmptyState, {
            icon: /*#__PURE__*/ React.createElement(ErrorIcon, null),
            tone: "neutral",
            text: t("workflows.loadFailed"),
            actions: /*#__PURE__*/ React.createElement(Button, {
                variant: "tonal",
                onClick: handleRetry
            }, t("generic.retry"))
        });
    }
    if (tree.showNoItemsMessage) {
        return /*#__PURE__*/ React.createElement(EmptyState, {
            icon: /*#__PURE__*/ React.createElement(EmptyIcon, null),
            title: emptyTitle,
            text: emptyText
        });
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SearchField, {
        value: tree.search,
        onChange: handleSearch,
        placeholder: searchPlaceholder,
        loading: tree.isSearching
    }), tree.isLoading && /*#__PURE__*/ React.createElement(CenteredSpinner, null, /*#__PURE__*/ React.createElement(Spinner, {
        size: "lg"
    })), !tree.isLoading && !items.length && /*#__PURE__*/ React.createElement(EmptyState, {
        icon: /*#__PURE__*/ React.createElement(SearchIcon, null),
        title: t("workflows.noMatches")
    }), /*#__PURE__*/ React.createElement(TreeList, {
        "aria-label": label,
        items: items,
        selectionMode: "single",
        selectedItems: tree.selectedItem,
        onSelectedItemsChange: handleSelectedItemsChange,
        expandedItems: tree.expandedItems,
        onExpandedItemsChange: handleExpandedItemsChange,
        showRootsAsSections: true,
        getItemIcon: (item, { isParent })=>{
            const Icon = getIconFromType(item.type, item.isAbstract);
            return Icon ? /*#__PURE__*/ React.createElement(Icon, {
                size: isParent ? 16 : 14
            }) : undefined;
        }
    }));
}
